export enum IClickToTextCreateFieldEnum {
  name = 'name',
  title = 'title',
  message = 'message',
  numbers = 'numbers',
  tags = 'tags',
  is_active = 'is_active',
}

export type IClickToTextCreateField = `${IClickToTextCreateFieldEnum}`

export enum EnumModeClickToText {
  create = 'create',
  edit = 'edit',
}
